module.exports = __webpack_public_path__ + "img/04.f44b9749.jpg";